import { cx } from 'class-variance-authority';
import { type ComponentPropsWithoutRef } from 'react';

const SliderButton = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'button'>) => (
  <button
    {...props}
    className={cx(
      'absolute flex size-16 items-center justify-center rounded-full',
      'border-2 border-solid border-sandstone-200',
      'text-heading-base text-sandstone-200',
      'lg:size-24 lg:text-heading-2xl',
      'hover:bg-sandstone-200/20',
      'disabled:opacity-20',
      className,
    )}
    data-cy="careers-gallery-slider-button"
    type="button"
  >
    {children}
  </button>
);

export default SliderButton;
